
/*
 * UNBEGUN Custom Size — PDP Display 1.1
 *
 * Compatible with automatic custom-size selection.
 *
 * - Keeps the Shopify size selector fully interactive.
 * - Does not overwrite the selected size visually.
 * - Shows custom delivery messaging when custom sizing is active.
 * - Restores normal stock messaging for standard variants.
 * - Supports NL / EN / DE / FR.
 */

(() => {
  'use strict';

  const translations = {
    nl: {
      delivery: 'Op maat gemaakt • Verzonden binnen 5–10 werkdagen'
    },
    en: {
      delivery: 'Made to measure • Ships within 5–10 business days'
    },
    de: {
      delivery: 'Maßanfertigung • Versand innerhalb von 5–10 Werktagen'
    },
    fr: {
      delivery: 'Sur mesure • Expédition sous 5 à 10 jours ouvrés'
    }
  };

  function getTranslation() {
    const lang = (document.documentElement.lang || 'nl')
      .slice(0, 2)
      .toLowerCase();

    return translations[lang] || translations.nl;
  }

  function init(module) {
    if (module.dataset.customSizeDisplayReady === 'true') {
      return;
    }

    const form = module.closest('form[data-product-form]');
    const toggle = module.querySelector('[data-custom-size-toggle]');

    if (!form || !toggle) return;

    const labels = getTranslation();

    const delivery = form.querySelector(
      '[data-unbegun-stock-message]'
    );

    let customDelivery = null;

    if (delivery) {
      customDelivery = document.createElement('p');

      customDelivery.className = delivery.className;
      customDelivery.textContent = labels.delivery;
      customDelivery.hidden = true;

      customDelivery.setAttribute(
        'data-unbegun-custom-delivery',
        ''
      );

      delivery.after(customDelivery);
    }

    function update() {
      const active = toggle.checked;

      if (!delivery || !customDelivery) return;

      if (active) {
        delivery.hidden = true;
        customDelivery.hidden = false;
      } else {
        customDelivery.hidden = true;

        /*
         * The existing stock module remains responsible
         * for normal stock availability messaging.
         */

        const variantSelect = form.querySelector(
          '[data-variant-select]'
        );

        const selected = variantSelect?.selectedOptions?.[0];

        if (selected && !selected.disabled) {
          delivery.hidden = false;
        }
      }
    }

    toggle.addEventListener('change', update);

    /*
     * The stock module may update its message when
     * the selected Shopify variant changes.
     */

    if (delivery && customDelivery) {
      const observer = new MutationObserver(() => {
        if (toggle.checked && !delivery.hidden) {
          delivery.hidden = true;
        }
      });

      observer.observe(delivery, {
        attributes: true,
        attributeFilter: ['hidden']
      });
    }

    module.dataset.customSizeDisplayReady = 'true';

    update();
  }

  function initAll(root = document) {
    if (root.matches?.('[data-unbegun-custom-size]')) {
      init(root);
    }

    root.querySelectorAll?.(
      '[data-unbegun-custom-size]'
    ).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initAll()
    );
  } else {
    initAll();
  }

  document.addEventListener(
    'shopify:section:load',
    event => initAll(event.target)
  );
})();